
import { defineComponent, ref } from "vue";
import { Roles, Menu } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { ElMessage } from "element-plus";
import type { ElTree } from "element-plus";
import type Node from "element-plus/es/components/tree/src/model/node";

interface DataForm {
  nMaNhomQuyen: number | null;
  cTenNhomQuyen: string | null;
}

interface Role {
  nMaChucNang: number | null;
  cMoTa: string | null;
  cNguoiCapNhatCuoi: string | null;
  cNguoiTao: string | null;
  cTenNhomQuyen: string | null;
  dNgayCapNhatCuoi: string | null;
  dNgayTao: string | null;
  nMaNhomQuyen: number | null;
  nTinhTrang: number | null;
}

interface RoleMenus {
  cIcon: string | null;
  cNguoiCapNhatCuoi: string | null;
  cNguoiTao: string | null;
  cQuyen: string | null;
  cTenChucNang: string | null;
  cUrl: string | null;
  children?: Array<RoleMenus> | null;
  dNgayCapNhatCuoi: string | null;
  dNgayTao: string | null;
  level: number | null;
  nChucNangNguoiDung: string | null;
  nChucNangQuanTriVien: string | null;
  nLoai: number | null;
  nMaChucNang: number | null;
  nMaChucNangCha: number | null;
  nThuTu: number | null;
  nTinhTrang: number | null;
  parentName: string | null;
  userName: string | null;
}

export default defineComponent({
  name: "kt-modal-role-menu",
  props: {
    data: Object,
    size: String,
  },
  emits: ["finish"],
  components: {},
  setup(props) {
    const checkStrictly = ref<boolean>(false);
    const treeRef = ref<InstanceType<typeof ElTree>>();
    const menuTree = ref<Array<RoleMenus>>([]);
    const selectedMenu = ref<Array<RoleMenus>>([]);
    const treeProp = ref({
      cIcon: "cIcon",
      cNguoiCapNhatCuoi: "cNguoiCapNhatCuoi",
      cNguoiTao: "cNguoiTao",
      cQuyen: "cQuyen",
      cTenChucNang: "label",
      cUrl: "cUrl",
      children: "children",
      dNgayCapNhatCuoi: "dNgayCapNhatCuoi",
      dNgayTao: "dNgayTao",
      level: "level",
      nChucNangNguoiDung: "nChucNangNguoiDung",
      nChucNangQuanTriVien: "nChucNangQuanTriVien",
      nLoai: "nLoai",
      nMaChucNang: "nMaChucNang",
      nMaChucNangCha: "nMaChucNangCha",
      nThuTu: "nThuTu",
      nTinhTrang: "nTinhTrang",
      parentName: "parentName",
      userName: "userName",
    });
    const selected = ref<Role>();
    const checkAll = ref<boolean>(false);
    const store = ref(useStore());
    const data1 = ref<DataForm>(props.data as DataForm);
    return {
      checkStrictly,
      data1,
      treeRef,
      menuTree,
      selectedMenu,
      treeProp,
      selected,
      checkAll,
      store,
    };
  },
  methods: {
    /* Find Menu Tree start */
    handleFindRoleMenu(item) {
      this.checkStrictly = true;
      const data = { nMaNhomQuyen: item.nMaNhomQuyen };
      this.selected = Object.assign({}, item);
      this.store.dispatch(Roles.findRoleMenu, data).then(async (res) => {
        if (res.code == 200) {
          this.selectedMenu = res.data as Array<RoleMenus>;
          await this.treeRef?.setCheckedNodes(res.data);
          this.checkStrictly = false;
        } else {
          ElMessage({ message: "Thất bại! " + res.msg, type: "error" });
        }
      });
      return item.cTenNhomQuyen;
    },

    handleFindMenuTree() {
      this.store.dispatch(Menu.findMenuTree, {}).then((res) => {
        if (res.code == 200) {
          this.menuTree = res.data;
        }
      });
    },

    /* draw tree */
    renderContent(
      h,
      {
        node,
        data,
        store,
      }: { node: Node; data: RoleMenus; store: Node["store"] }
    ) {
      return h(
        "span",
        {
          class: "custom-tree-node",
          style: "width:100%; display:flex",
        },
        h(
          "span",
          {
            class: "role-tree-node",
            style: "width:25%",
          },
          null,
          data.cTenChucNang
        ),
        h(
          "span",
          {
            class: "role-tree-node",
            style: "width:10%",
          },
          null,
          h("i", { class: `${data.cIcon}` })
        ),
        h(
          "span",
          {
            class: "role-tree-node",
            style: "width:20%",
          },
          null,
          `${data.nLoai === 1
            ? "Menu Gốc"
            : data.nLoai === 2
              ? "Menu"
              : data.nLoai === 3
                ? "Button"
                : data.nLoai === 4
                  ? "Liên kết ngoài"
                  : ""
          }`
        ),
        h(
          "span",
          {
            class: "role-tree-node",
            style: "width:30%",
          },
          null,
          data.cQuyen
        ),
        h(
          "span",
          {
            class: "role-tree-node",
            style: "width:15%",
          },
          null,
          data.cUrl
        )
      );
    },

    /* check all tree nodes start */
    handleCheckAll() {
      if (this.checkAll) {
        let allMenus = [];
        this.checkAllMenu(this.menuTree, allMenus);
        this.treeRef?.setCheckedNodes(allMenus);
      } else {
        this.treeRef?.setCheckedNodes([]);
      }
    },

    checkAllMenu(data, allMenus) {
      data.forEach((menu) => {
        allMenus.push(menu);
        if (menu.children) {
          this.checkAllMenu(menu.children, allMenus);
        }
      });
    },

    /* check all tree nodes end */

    /* save role menu  */
    saveRoleMenu() {
      let roleId = this.selected?.nMaNhomQuyen;
      let checkedNodes = this.treeRef?.getCheckedNodes(
        false,
        true
      ) as Array<Role>;
      let roleMenus = [] as Array<{
        nMaNhomQuyen: number | null | undefined;
        nMaChucNang: number | null;
      }>;
      for (let i = 0; i < checkedNodes.length; i++) {
        let roleMenu = {
          nMaNhomQuyen: roleId,
          nMaChucNang: checkedNodes[i].nMaChucNang,
        };
        roleMenus.push(roleMenu);
      }
      if (roleMenus.length == 0) {
        roleMenus.push({
          nMaNhomQuyen: roleId as number,
          nMaChucNang: null
        })
      }
      this.store.dispatch(Roles.saveRoleMenu, roleMenus).then((res) => {
        if (res.code == 200) {
          ElMessage({ message: "Lưu thành công", type: "success" });
          this.handleFindRoleMenu(this.selected);
        } else {
          ElMessage({ message: "Thất bại! " + res.msg, type: "error" });
        }
      });
    },

    /* reset role menu */
    resetRoleMenu() {
      this.checkAll = false;
      let selectedMenuData = [] as any;
      this.selectedMenu.forEach((menu) => {
        selectedMenuData.push(menu);
      });
      this.treeRef?.setCheckedNodes(selectedMenuData);
    },
  },
  mounted() {
    this.handleFindMenuTree();
    this.handleFindRoleMenu(this.data1);
  },
});
